// src/pages/PaymentPage.js
import React from 'react';
import { useLang } from '../i18n/LanguageContext';
import { waLink } from '../data/contact';
import UpiPayment from '../components/Payment/UpiPayment';
import PaymentConfirmForm from '../components/Payment/PaymentConfirmForm';
import { Breadcrumb, usePageTitle } from '../components/layout/PageBits';

// Plain utility page: fraud warning first, then pay, then confirm. No pop-ups, no distractions.
function PaymentPage() {
  const { t } = useLang();
  usePageTitle(t('pay'));
  return (
    <div className="bg-slate-50 min-h-screen">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <Breadcrumb current={t('pay')} />
        <h1 className="text-3xl sm:text-4xl font-extrabold">{t('payTitle')}</h1>
        <div className="mt-5 flex gap-3 items-start bg-amber-50 border border-amber-300 text-amber-900 rounded-2xl p-4" role="note">
          <span className="text-xl" aria-hidden="true">⚠️</span>
          <div className="text-sm leading-relaxed"><b>{t('payWarnTitle')}</b> {t('payWarn')}</div>
        </div>
        <div className="mt-8 grid lg:grid-cols-2 gap-6">
          <section className="bg-white rounded-3xl shadow-sm border border-slate-200 p-6 sm:p-8">
            <div className="flex items-center gap-3 mb-6"><span className="w-8 h-8 rounded-full bg-brand text-white font-bold flex items-center justify-center">1</span><h2 className="text-xl font-extrabold">{t('payStep1')}</h2></div>
            <UpiPayment />
          </section>
          <section className="bg-white rounded-3xl shadow-sm border border-slate-200 p-6 sm:p-8">
            <div className="flex items-center gap-3 mb-6"><span className="w-8 h-8 rounded-full bg-brand text-white font-bold flex items-center justify-center">2</span><h2 className="text-xl font-extrabold">{t('payStep2')}</h2></div>
            <PaymentConfirmForm />
            <div className="mt-6 pt-6 border-t border-slate-100 text-center">
              <p className="text-sm text-slate-500">{t('payOrWa')}</p>
              <a href={waLink(t('payWaMsg'))} target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex bg-emerald-500 hover:bg-emerald-600 text-white font-bold px-5 py-3 rounded-xl">💬 {t('paySendReceipt')}</a>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PaymentPage;
